import React, { ChangeEvent } from 'react';
import classNames from 'classnames';
import { Field } from 'formik';
import { OptionType } from 'V2/Types';
import { Errors } from '../Errors';
import { FieldRenderProps } from '../types';
import { SelectInputType } from './types';
import styles from './styles.module.css';
import cx from 'classnames';

export const SelectInput: React.FC<SelectInputType> = ({
  onChange,
  label,
  options,
  name,
  dataTestId,
  disabled: disabledField,
  variant,
  className: inputClassName,
  style: inputStyle,
  ...inputProps
}) => (
  <Field name={name}>
    {({ field, form }: FieldRenderProps) => (
      <>
        <div className={styles.group} data-testid={name}>
          <select
            data-testid={dataTestId ?? 'select'}
            {...field}
            {...inputProps}
            onChange={(event: ChangeEvent<HTMLSelectElement>) => {
              field.onChange(event);

              if (onChange) {
                onChange(event);
              }
            }}
            className={classNames(styles.select, inputClassName, {
              [styles.selected]: field.value !== null && field.value !== '',
              [styles.flat]: variant === 'flat',
              [styles.noLabel]: !label,
            })}
            style={inputStyle}
            disabled={disabledField}
            id={field.name}
          >
            <option disabled hidden className={styles.defaultOption} />
            {options.map((option: OptionType, i: number) =>
              option.options && option.options.length > 0 ? (
                <optgroup label={option.label} key={i}>
                  {option.options.map((group: OptionType, i: number) => (
                    <option value={`${group.value}`} key={i}>
                      {group.label}
                    </option>
                  ))}
                </optgroup>
              ) : (
                <option value={`${option.value}`} key={i}>
                  {option.label}
                </option>
              )
            )}
          </select>
          <label
            className={cx(styles.label, !label && styles.hide)}
            data-testid="label"
            htmlFor={field.name}
          >
            {label}
          </label>
        </div>
        <Errors fieldName={name} formStatus={form.status} />
      </>
    )}
  </Field>
);
